import IowaCityHeroSection from "./components/HeroSection";
import IowaCityStickyNav from "./components/StickyNav";
import IowaCityProcessingTimeSection from "./components/ProcessingTimeSection";
import IowaCityServicesSection from "./components/ServicesSection";
import IowaCityLocalAreaSection from "./components/LocalAreaSection";
import IowaCityTestimonialsSection from "./components/TestimonialsSection";
import IowaCityAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import IowaCityComparisonSection from "./components/ComparisonSection";
import IowaCityMistakesSection from "./components/MistakesSection";
import IowaCityHowItWorksSection from "./components/HowItWorksSection";
import IowaCityFAQSection, { faqs } from "./components/FAQSection";
import IowaCityHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import IowaCityFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const faqsMapped = faqs.map((f: { q: string; a: string }) => ({ q: f.q, a: f.a }));

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function IowaCityPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Iowa City"
        state="Iowa"
        stateAbbr="IA"
        route="/iowa-city"
        title="Emergency Passport Iowa City, IA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Iowa City, IA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Johnson County and University of Iowa travelers."
        geoPlacename="Iowa City, Iowa"
        geoPosition="41.6611;-91.5302"
        faqs={faqsMapped}
        servicesSchema={servicesSchema}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
        keywords="expedited passport, emergency passport, Iowa City passport, same day passport Iowa City, fast passport Iowa, University of Iowa passport, Johnson County passport"
      />
      <IowaCityHeroSection />
      <IowaCityStickyNav />
      <IowaCityProcessingTimeSection />
      <IowaCityLocalAreaSection />
      <IowaCityServicesSection />
      <IowaCityTestimonialsSection />
      <IowaCityAcceptanceFacilitiesSection />
      <IowaCityComparisonSection />
      <IowaCityMistakesSection />
      <IowaCityHowItWorksSection />
      <IowaCityFAQSection />
      <IowaCityHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/iowa-city" state="IA" />
      <IowaCityFinalCTA />
    </div>
  );
}